import axios from 'axios';
import { IsHtml } from '../shared/Functions';
import DOMPurify from 'dompurify';

export async function HandleAddNote(note) {
    const url = 'api/crmNoteFront/addNote/';
    if (IsHtml(note.text)) {
        note.text = DOMPurify.sanitize(note.text);
    }
    const res = await axios.post(url, note).then(
        (response) => {
            if (response.status === 200) {
                return { success: true, error: null, data: response.data };
            } else {
                return { success: false, error: response.data.message, data: null };
            }
        },
        (error) => {
            return { success: false, error: 'Det gick inte att spara ändringen, vänligen kontakta alltid@consid.se.', data: null };
        }
    );

    return res;
}

export async function HandleUpdateNote(note) {
    const url = 'api/crmNoteFront/updateNote/';
    if (IsHtml(note.text)) {
        note.text = DOMPurify.sanitize(note.text);
    }
    const res = await axios.put(url, note).then(
        (response) => {
            if (response.status === 200) {
                return { success: true, error: null, data: response.data };
            } else {
                return { success: false, error: response.data.message, data: null };
            }
        },
        (error) => {
            return { success: false, error: 'Det gick inte att spara ändringen, vänligen kontakta alltid@consid.se.', data: null };
        }
    );

    return res;
}

export async function HandleRemoveNote(note) {
    const url = 'api/crmNoteFront/removeNote/';
    const query = { noteId: note.id };

    const res = await axios.delete(url, { params: query }).then(
        (response) => {
            if (response.status === 200) {
                return { success: true, error: null, data: response.data };
            } else {
                return { success: false, error: response.data.message, data: null };
            }
        },
        (error) => {
            return { success: false, error: 'Det gick inte att spara ändringen, vänligen kontakta alltid@consid.se.', data: null };
        }
    );

    return res;
}
